export default "__VITE_ASSET__CwKK4894__"